import React, { useEffect, useState } from 'react';
import AWS from 'aws-sdk';
import userPoolData from '../../UserPool';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { insertLog } from '../Logs/InsertLog';
import UsersDS from '../../DataServices/UsersDs';

AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_AWS_REGION,
});


const cognitoISP = new AWS.CognitoIdentityServiceProvider();

export const UsersLogic = () => {
    const [users, setUsers] = useState([]);
    const currentUserEmail = localStorage.getItem("email")?.toLowerCase();
    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();

    const useremail = localStorage.getItem("email");
    const userName = useremail?.split('@')[0];

    const userAttorney = new UsersDS();
    const accessLevelList = [
        { value: "1", name: "Attorney" },
        { value: "2", name: "Manager" },
        { value: "3", name: "Admin" }
    ]

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        hud("Please Wait...");
        try {
            const params = { UserPoolId: userPoolData.userPoolId };
            const data = await cognitoISP.listUsers(params).promise();

            const filteredAndSortedUsers = data.Users
                .filter(user => {
                    const emailAttr = user.Attributes.find(attr => attr.Name === 'email');
                    return emailAttr && emailAttr.Value.toLowerCase() !== currentUserEmail;
                })
                .sort((a, b) => new Date(b.UserLastModifiedDate) - new Date(a.UserLastModifiedDate));

            setUsers(filteredAndSortedUsers);
            console.log("Filtered Users:", filteredAndSortedUsers);
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            stopHudRotation();
        }
    };

    const handleConfirmUser = async (username) => {
        hud("Please wait...");

        try {
            // Confirm user (updates UserStatus to CONFIRMED)
            await cognitoISP.adminConfirmSignUp({
                UserPoolId: userPoolData.userPoolId, // replace with your pool ID
                Username: username
            }).promise();

            // Optionally mark email as verified
            await cognitoISP.adminUpdateUserAttributes({
                UserPoolId: userPoolData.userPoolId,
                Username: username,
                UserAttributes: [
                    {
                        Name: 'email_verified',
                        Value: 'true'
                    }
                ]
            }).promise();

            // showAlert("User confirmed successfully", [
            //     { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            // ]);
            showToast({ message: "User confirmed successfully" });

            fetchUsers(); // Refresh user list
            insertLog(
                `${userName} confirmed the user ${username}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert
            );
        } catch (error) {
            console.error('Confirmation failed:', error);
            showAlert("Failed to confirm user", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
        } finally {
            stopHudRotation();
        }
    };


    const handleApproveUser = async (username) => {
        hud("Please Wait...");

        try {
            // Find the user from the local users list
            const user = users.find((u) => u.Username === username);
            if (!user) throw new Error("User not found");
            const emailAttr = user.Attributes.find(attr => attr.Name === 'email');
            const targetUserEmail = emailAttr?.Value?.split('@')[0] || username;
            // Extract empInfo attribute
            const empInfoAttr = user.Attributes.find((attr) => attr.Name === 'custom:empInfo');
            if (!empInfoAttr) throw new Error("custom:empInfo attribute not found");

            const empInfo = JSON.parse(empInfoAttr.Value);
            const empName = empInfo?.name || userName;

            if (empInfo.accessLevel === 1 && !empInfo.Zoho_Referring_Source_ID) {
                const zohoId = await ReferralSourceADD(emailAttr?.Value, empName);

                if (zohoId) {
                    empInfo.Zoho_Referring_Source_ID = zohoId;
                    await insertLog(
                        `${userName} created Zoho Referring Source for ${targetUserEmail}`,
                        0,
                        useremail,
                        hud,
                        stopHudRotation,
                        showAlert
                    );
                } else {
                    return; // stop if Zoho creation failed
                }
            }


            // Update isEmployeeActive
            empInfo.isEmployeeApproved = true;

            // Update the attribute in Cognito
            await cognitoISP.adminUpdateUserAttributes({
                UserPoolId: userPoolData.userPoolId,
                Username: username,
                UserAttributes: [
                    {
                        Name: 'custom:empInfo',
                        Value: JSON.stringify(empInfo),
                    },
                ],
            }).promise();

            // showAlert(`User is approved`,
            //     [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]
            // );
            showToast({ message: "User is approved" });

            fetchUsers();
            insertLog(
                `${userName} approved the user ${targetUserEmail}`, // description
                0,                                                  // referralID (optional or actual number)
                useremail,                                          // userEmail
                hud,
                stopHudRotation,
                showAlert
            );

        } catch (error) {
            console.error(' failed:', error);
            showAlert('Failed to approved user', [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]);
        } finally {
            stopHudRotation();

        }
    };
    const ReferralSourceADD = async (email, empName) => {
        try {
            hud("Please Wait...");

            const requestData = {
                Email: email,
                Name: empName,
            };

            // console.log("Zoho Attorney request:", requestData);
            // 🔄 Call your API for creating Zoho attorney
            const response = await userAttorney.RM_Referral_Source_ADD(requestData);
            const data = response.data;

            if (data.statusCode !== 200) {
                const message = data.body?.message || "Failed to create Zoho attorney";
                showToast({ message });
                return;
            }

            // Parse body (string → JSON)
            let parsedBody;
            try {
                parsedBody = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            } catch (err) {
                parsedBody = {};
            }

            const zohoId = parsedBody?.Zoho_Referring_Source_ID;

            if (!zohoId) {
                showToast({ message: parsedBody?.message || "No Zoho Attorney ID returned" });
                return;
            }



            // ✅ Log Zoho attorney creation


            // showToast({ message: parsedBody?.message || "Zoho Attorney created successfully" });
            return zohoId;

        } catch (error) {
            const message =
                error?.response?.data?.message || error.message || "Zoho attorney creation error";
            showToast({ message });
            return null;
        } finally {
            stopHudRotation();
        }
    }

    const handleToggleEmployeeActive = async (username, shouldActivate) => {
        hud("Please Wait...");

        try {
            // Find the user from the local users list
            const user = users.find((u) => u.Username === username);
            if (!user) throw new Error("User not found");
            const emailAttr = user.Attributes.find(attr => attr.Name === 'email');
            const targetUserEmail = emailAttr?.Value?.split('@')[0] || username;
            // Extract empInfo attribute
            const empInfoAttr = user.Attributes.find((attr) => attr.Name === 'custom:empInfo');
            if (!empInfoAttr) throw new Error("custom:empInfo attribute not found");

            const empInfo = JSON.parse(empInfoAttr.Value);

            // Update isEmployeeActive
            empInfo.isEmployeeActive = shouldActivate;

            // Update the attribute in Cognito
            await cognitoISP.adminUpdateUserAttributes({
                UserPoolId: userPoolData.userPoolId,
                Username: username,
                UserAttributes: [
                    {
                        Name: 'custom:empInfo',
                        Value: JSON.stringify(empInfo),
                    },
                ],
            }).promise();

            // showAlert(
            //     `User ${shouldActivate ? 'activated' : 'disabled'} successfully`,
            //     [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]
            // );
            showToast({ message: `User ${shouldActivate ? 'activated' : 'disabled'} successfully` });
            fetchUsers();
            insertLog(
                `${userName} ${shouldActivate ? 'activated' : 'disabled'} user ${targetUserEmail}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert
            );

        } catch (error) {
            console.error(`${shouldActivate ? 'Activation' : 'Disable'} failed:`, error);
            showAlert('Failed to update user status', [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]);
        } finally {
            stopHudRotation();
        }
    };


    const handleAccessLevelChange = async (username, newLevel) => {
        hud("Please Wait...");
        try {
            const user = users.find((u) => u.Username === username);
            if (!user) return;
            const emailAttr = user.Attributes.find(attr => attr.Name === 'email');
            const targetUserEmail = emailAttr?.Value?.split('@')[0] || username;

            const empInfoAttr = user.Attributes.find(attr => attr.Name === 'custom:empInfo');
            let empInfo = {};
            if (empInfoAttr?.Value) {
                empInfo = JSON.parse(empInfoAttr.Value);
            }
            const empName = empInfo?.name || userName;

            if (parseInt(newLevel) === 1 && !empInfo.Zoho_Referring_Source_ID) {
                const zohoId = await ReferralSourceADD(emailAttr?.Value, empName);

                if (!zohoId) {
                    showToast({ message: "Failed to create Zoho Referring Source ID" });
                    return; // stop if Zoho creation failed
                }
                empInfo.Zoho_Referring_Source_ID = zohoId;
                await insertLog(
                    `${userName} created Zoho Referring Source for ${targetUserEmail}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert
                );
            }


            empInfo.accessLevel = parseInt(newLevel);

            await cognitoISP.adminUpdateUserAttributes({
                UserPoolId: userPoolData.userPoolId,
                Username: username,
                UserAttributes: [{
                    Name: 'custom:empInfo',
                    Value: JSON.stringify(empInfo),
                }]
            }).promise();

            const accessLevelName = accessLevelList.find(item => item.value === newLevel?.toString())?.name || newLevel;
            // showAlert(`Access level updated to "${accessLevelName}"`, [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]);
            showToast({ message: `Access level updated to "${accessLevelName}"` });

            fetchUsers();
            insertLog(
                `${userName} changed access level of user ${targetUserEmail} to "${accessLevelName}"`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert
            );

        } catch (error) {
            console.error('Error updating access level:', error);
            showAlert('Failed to update access level', [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]);
        } finally {
            stopHudRotation();
        }
    };

    return (
        { users, accessLevelList, handleConfirmUser, handleApproveUser, handleToggleEmployeeActive, handleAccessLevelChange }
    )
}
